app.service('productInstalmentsModal', function (modal, productCardConfig, productTabInstalments, store, loading, log, productCardManager, stackedModal) {

	let $self, $addCAInstalment, $addMainInstalment;
	let selectedWarrantyId;

	function show(props) {
		selectedWarrantyId = props && props.warrantyId;
		load();
	}

	function setElements() {
		$self = $('#installments');

		$addCAInstalment = $('.js-add-ca-instalment', $self);
		$addMainInstalment = $('.js-add-main-instalment', $self);
	}

	function setEvents() {
		$addCAInstalment.on('click', handleAddInstalmentClick);
		$addMainInstalment.on('click', handleAddInstalmentClick);
	}

	function handleAddInstalmentClick() {
		const instalmentWarrantyId = +$(this).data('warrantyId');
		const paymentType = $(this).data('payment');
		const {code, number} = productTabInstalments.getData();

		if (instalmentWarrantyId) {
			store.dispatch('changeInstalment', {
				code,
				number,
				paymentType,
				instalmentWarrantyId
			});
			log.event({
				"id": "Raty przez internet KP",
				"f03": document.location.href,
				"f04": "Kupuje na raty przez internet",
				"f05": "klik",
				"f06": productCardConfig.getData().plu,
				"f07": code,
				"f08": instalmentWarrantyId ? instalmentWarrantyId : ""
			});
		} else {
			if (selectedWarrantyId) {
				const warrantyAddedFrom = 'PRODUCT_CARD_INSTALLMENT_WITH_WARRANTY';
				productCardManager.addWarranty(selectedWarrantyId, paymentType, warrantyAddedFrom);
			} else {
				productCardManager.removeWarranty();
			}

			store.dispatch('changeInstalment', {
				code,
				number,
				paymentType
			});
		}

		stackedModal.clearStack();
		modal.close();
		UA.interaction('KP_Crossell', 'Raty_modal', 'Wybierz_raty_przez_internet');
	}

	function load() {
		let productId = productCardConfig.getData().id;
		let outletCategoryId = store.data.outletCategoryId || undefined;
		loading.start();

		$.ajax({
			url: '/product-card-instalment.ltr',
			data: {
				productId,
				outletCategoryId
			}
		})
			.then(html => loadSuccess(html))
			.fail(function(a){
				console.log(a)
				modal.alert('Błąd pobierania modala ratalnego.')
			})
			.always(loading.stop);
	}

	function loadSuccess(html) {
		let currentInstalment = {
			code: store.data.instalmentCode,
			number: store.data.instalmentNumber,
			warrantyId: store.data.instalmentWarrantyId
		};

		const modalInstance = modal.generate({
			id: 'installments',
			header: '<div class="modal-title">Wybierz swoją ofertę ratalną:</div>',
			content: html,
			closeOnOutsideClick: false,
			callbackOpen: function () {
				setElements();
				setEvents();
				console.log(currentInstalment);
				productTabInstalments.init(currentInstalment);
			}
		});

		modalInstance.$wrapper.on('mousedown', (e) => {
			$(e.target).hasClass('remodal-wrapper') && modalInstance.close()
		})

		stackedModal.push(modalInstance);
	}

	return {
		show: show
	};
});
